module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Elodie-meisje-letterpress-roze-2.7a25dcb8.jpg";